module.exports = __webpack_public_path__ + "static/scale-model-of-bennett-place-in-durham-north-carolina-f9bc929d415e5c2a0346c34d0b69b530.png";